<template>
  <div class="ed">
    <div class="box_2 flex-col">
      <div class="block_18 flex-row justify-between">
        <span class="text_6">{{ info.inquiryRequestVO.inquiryNo || '-' }}</span>
        <div class="text-wrapper_1 flex-col"><span class="text_7">{{ info.inquiryRequestVO.documentText || '-' }}</span></div>
      </div>
      <div class="block_19 flex-row">
        <div class="text-wrapper_2">
          <span class="text_8">已收到</span>
          <span class="text_9">{{ quoteCount }}</span>
          <span class="text_10">份报价，来自</span>
          <span class="text_11">{{ companyCount }}</span>
          <span class="text_12">家公司，还有</span>
          <span class="text_13">{{ unquotedSkuCount }}</span>
          <span class="text_14">个型号没有收到报价。</span>
        </div>
        <div class="right-block">
          <div class="text-wrapper_3">
            <span class="text_15">制单时间：</span>
            <span class="text_16">{{ info.inquiryRequestVO.documentTime || '-' }}</span>
          </div>
          <span class="thumbnail_11"></span>
          <div class="link_wrap">
            <span class="text_17">询价链接：</span>
          <div class="link-tooltip-wrapper">
            <span class="text_18" id="copyCode">{{ shareLink }}</span>
            <div class="tooltip-content">{{ shareLink }}</div>
          </div>
          </div>
          <span class="thumbnail_11"></span>

          <span class="text_19" style="cursor:pointer;color:#48a09c" @click="copy">复制</span>
          <span class="thumbnail_11"></span>

          <span class="text_20" style="cursor:pointer;color:#48a09c" @click="exportOffer">分享下载二维码</span>

        </div>
      </div>
      <div class="line-mini"></div>
      <div class="block_20 flex-row justify-between">
        <div class="box_30 flex-col">
          <div class="text-wrapper_4 flex-col"><span class="text_21">采购记录</span></div>
          <div class="box_6 flex-col" style="overflow: auto">
            <el-table :data="purchaseRecords" border height="180" :stripe="true" >
              <el-table-column type="index" label="序号" width="60" />
              <el-table-column prop="documentDate" label="时间" />
              <el-table-column prop="sellerEnterpriseName" label="被采购公司" />
              <el-table-column label="采购单号">
                <template #default="{ row }">
                  <el-link type="primary" :underline="false" @click="goPurchaseDetails(row)">
                    {{ row.documentNumber || "-" }}
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column label="订货号" min-width="180">
                <template #default="{ row }">
                  <div class="purchase-record-cell">
                    <el-tooltip
                      v-if="hasMultiplePurchaseRecordItems(row)"
                      :content="getPurchaseRecordTooltipContent(row)"
                      placement="top"
                      effect="light"
                    >
                      <span class="purchase-record-primary">{{ getPurchaseRecordFirstValue(row.articleNo) }}</span>
                    </el-tooltip>
                    <span v-else class="purchase-record-primary">{{ getPurchaseRecordFirstValue(row.articleNo) }}</span>
                    <el-popover
                      v-if="hasMultiplePurchaseRecordItems(row)"
                      placement="top-start"
                      width="320"
                      trigger="click"
                    >
                      <div class="purchase-record-popover">
                        <div
                          v-for="(item, index) in getPurchaseRecordEntries(row)"
                          :key="`articleNo-${index}`"
                          class="purchase-record-popover-item"
                        >
                          <span class="purchase-record-popover-col">{{ item.articleNo }}</span>
                          <span class="purchase-record-popover-col">{{ item.barCode }}</span>
                          <span class="purchase-record-popover-col">{{ item.skuPurchaseQty }}</span>
                        </div>
                      </div>
                      <template #reference>
                        <span class="purchase-record-more">查看全部</span>
                      </template>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="型号" min-width="180">
                <template #default="{ row }">
                  <div class="purchase-record-cell">
                    <el-tooltip
                      v-if="hasMultiplePurchaseRecordItems(row)"
                      :content="getPurchaseRecordTooltipContent(row)"
                      placement="top"
                      effect="light"
                    >
                      <span class="purchase-record-primary">{{ getPurchaseRecordFirstValue(row.barCode) }}</span>
                    </el-tooltip>
                    <span v-else class="purchase-record-primary">{{ getPurchaseRecordFirstValue(row.barCode) }}</span>
                    <el-popover
                      v-if="hasMultiplePurchaseRecordItems(row)"
                      placement="top-start"
                      width="320"
                      trigger="click"
                    >
                      <div class="purchase-record-popover">
                        <div
                          v-for="(item, index) in getPurchaseRecordEntries(row)"
                          :key="`barCode-${index}`"
                          class="purchase-record-popover-item"
                        >
                          <span class="purchase-record-popover-col">{{ item.articleNo }}</span>
                          <span class="purchase-record-popover-col">{{ item.barCode }}</span>
                          <span class="purchase-record-popover-col">{{ item.skuPurchaseQty }}</span>
                        </div>
                      </div>
                      <template #reference>
                        <span class="purchase-record-more">查看全部</span>
                      </template>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="purchasePrice" label="价格" width="100">
                <template #default="{ row }">
                  <span>￥{{ row.purchasePrice || 0 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="purchaseQty" label="采购数量" width="100" />
            </el-table>
          </div>
        </div>
        <div class="block_2 flex-col">
          <div class="section_2 flex-col"></div>
          <span class="paragraph_8">
            把二维码发给你的供应商，邀请他们报价，
            <br />
            你就能在下面对比表中查看。
          </span>
          <div class="image-wrapper_1 flex-col">
            <img
              class="image_5"
              referrerpolicy="no-referrer"
              :src="imageUrl"
            />
          </div>
          <div id="offerBox" style="padding: 16px; background: #fff; width: 320px; text-align: center; display: none">
            <div style="font-size: 16px; font-weight: 600; margin-bottom: 12px">
              {{ info.inquiryRequestVO.buyerEnterpriseName || "分享二维码" }}
            </div>
            <img :src="imageUrl" alt="询价二维码" style="width: 260px; height: 260px; object-fit: contain" />
            <div style="margin-top: 8px; color: #666">长按保存二维码</div>
          </div>
          <span class="text_37">询价二维码</span>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="tabs-container">
      <el-tabs v-model="activeNav">
        <el-tab-pane :name="item.type" :key="item.type" :disabled="item.disabled" v-for="item in navs">
          <template #label>
            <div class="custom-tab-label">
              <img 
                :src="getTabIcon(item.type, activeNav === item.type)" 
                class="tab-icon"
                alt=""
              />
              <span :class="['tab-text', { 'tab-text-active': activeNav === item.type }]">
                {{ item.title }}
              </span>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
      <div class="tabs-right">
        <span class="text_38">最终用户：</span>
        <span class="text_39">{{ info.inquiryRequestVO.inquiryCustomerName || '-' }}</span>
        <span class="thumbnail_11"></span>
        <span class="text_40">电话：</span>
        <span class="text_41">{{ info.inquiryRequestVO.inquiryCustomerPhone || '-' }}</span>
        <span class="thumbnail_12"></span>
        <span class="text_42">公司名称：</span>
        <span class="text_43">{{ info.inquiryRequestVO.inquiryEnterpriseName || '-' }}</span>
      </div>
    </div>
    <div class="ed-content">
      <component @bjSuccess="bjSuccess" :info="info" :inquiryId="$route.query.id" :is="comName"></component>
    </div>
  </div>
</template>

<script>
import html2Canvas from 'html2canvas'
import productInfo from "../components/enquiryDetails/productInfo.vue"; //产品信息
import inquiryInfo from "../components/enquiryDetails/inquiryInfo.vue"; //询价信息
import offerInfo1 from "../components/enquiryDetails/offerInfo1.vue"; //报价信息1（指定企业报价）
import offerInfo2 from "../components/enquiryDetails/offerInfo2.vue"; //报价信息2（全平台报价）
import editOfferInfo from "../../mysaleMudule/components/enquiryDetails/editOfferInfo.vue"; //编辑报价信息
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      navs: [
        { title: "询价信息", type: 3, name: "inquiryInfo" },
        { title: "产品信息", type: 2, name: "productInfo" },
      ],
      activeNav: 3,
      info: {
        inquiryRequestVO: {
          address: {},
        },
      },
      type: "my", //my我的询价详情 customer 客户询价详情(默认我的询价详情)
      id: "",
      protocol: window.location.protocol,
      host: window.location.host,
      userType: "",
      imageUrl: '',
      purchaseRecords: [],
      isAlive: true
    };
  },
  components: {
    productInfo,
    inquiryInfo,
    offerInfo1,
    offerInfo2,
    editOfferInfo,
  },
  methods: {
    ...mapActions("purchaseMudule", [
      "inquiryInfo" //获取询价详情
    ]),
    ...mapActions("mysaleMudule", [
      "purchasePage", //获取采购记录
    ]),
    downs(url) {
      var alink = document.createElement("a");
      alink.href = url;
      alink.download = "pic"; //图片名
      alink.click();
    },

    exportOffer() {
      var that = this
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      const imageWrapper = document.querySelector('#offerBox')
      html2Canvas(imageWrapper, {
        userCORS: true,
        dpi: 300, // 图片清晰度问题
        background: '#FFFFFF',
        scrollY: 0,
        scrollX: 0,
      }).then(function (canvas) {
        that.downs(canvas.toDataURL('image/jpeg', 1.0))
      })
    },
    imageUrlToBase64(src) {
      var that = this
      let image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      image.src =  src 
      image.onload = () => {
        if (!that.isAlive) return;
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        that.imageUrl = canvas.toDataURL("image/jpeg")
      }
    },
    getQrCode() {
        // 生成 H5 普通二维码，内容为询价详情 H5 页面链接，小程序扫描后可直接识别并跳转到对应的询价详情页
        const h5Url = `${this.protocol}//${this.host}/purchase/enquiryDetails?id=${this.$route.query.id}`
        const encodedUrl = encodeURIComponent(h5Url)
        // 使用 qrserver 公共 API 生成二维码图片，再转 base64 以支持 html2canvas 导出
        const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodedUrl}`
        this.imageUrlToBase64(qrUrl)
    },
  copy() {
    const range = document.createRange()
    range.selectNode(document.getElementById('copyCode'))
    const selection = window.getSelection()
    if (selection.rangeCount > 0) selection.removeAllRanges()
    selection.addRange(range)
    document.execCommand('copy')
    this.$message({
      message: '复制成功',
      type: 'success'
    })
    selection.removeRange(range)
  },
  getDetails() {
    //获取
    this.getQrCode()
    this.inquiryInfo({
      inquiryId: this.$route.query.id,
    }).then((res) => {
      if (!this.isAlive) return;
      let { code, data } = res.data;
      if (code === "0") {
        //data.inquiryRequestVO.documentTime  = moment(data.inquiryRequestVO.documentTime).format('YYYY.MM.DD hh:mm:ss');
        data.inquiryRequestVO.priceUnit = this.getType(
          "moneys",
          data.inquiryRequestVO.priceUnit
        );
        data.inquiryRequestVO.projectFile = JSON.parse(
          data.inquiryRequestVO.projectFile || "[]"
        );
        data.inquiryRequestVO.documentText =
          this.documentState[data.inquiryRequestVO.documentState];
        data.inquiryRequestVO.file = JSON.parse(
          data.inquiryRequestVO.file || "[]"
        );
        data.inquiryRequestVO.projectState = data.inquiryRequestVO
          .projectState
          ? this.getType("projectState", data.inquiryRequestVO.projectState)
          : "";
        data.inquiryRequestVO.paymentType = this.getType(
          "paymentTypes",
          data.inquiryRequestVO.paymentType
        );
        if (data.forEnterprise || data.forSku || this.type === "customer") {
          if (!this.navs.some((v) => v.type === 1)) {
            this.activeNav = 1;
            this.navs.push({
              title: "报价信息",
              type: 1,
              name: "offerInfo1",
            });
          }
          if (this.type === "customer") {
            this.navs[this.matchingIndex(1)].name = "editOfferInfo"; //编辑报价信息
          } else if (data.inquiryRequestVO.isPlatform === "1") {
            //全平台报价
            this.navs[this.matchingIndex(1)].name = "offerInfo2";
          } else {
            //指定企业报价
            this.navs[this.matchingIndex(1)].name = "offerInfo1";
          }
        }
        this.info = data; //商品列表
        // 获取采购记录
        this.getPurchaseRecords();
      }
    });
  },
  getPurchaseRecords() {
    this.purchasePage({
      pageNo: "1",
      pageSize: "999",
      inquiryId: this.id,
    }).then((res) => {
      if (!this.isAlive) return;
      if (res?.data?.code === "0") {
        this.purchaseRecords = res.data.data?.rows || [];
      }
    }).catch(() => {
      if (!this.isAlive) return;
      this.purchaseRecords = [];
    });
  },
  goPurchaseDetails(row) {
    const documentId = row.documentId || row.id;
    if (!documentId) {
      this.$message({
        message: "采购单ID为空，无法查看采购详情",
        type: "warning",
      });
      return;
    }
    this.$router.push({
      path: "/mysale/xinOrderDetails",
      query: {
        id: documentId,
        inquiryId: row.inquiryId || this.id,
        type: "_purchase",
      },
    });
  },
  splitPurchaseRecordValue(value) {
    return String(value || "")
      .split("|")
      .map((item) => item.trim())
      .filter((item) => item);
  },
  getPurchaseRecordEntries(row) {
    const articleNoList = this.splitPurchaseRecordValue(row.articleNo);
    const barCodeList = this.splitPurchaseRecordValue(row.barCode);
    const skuPurchaseQtyList = this.splitPurchaseRecordValue(row.skuPurchaseQty);
    const maxLength = Math.max(articleNoList.length, barCodeList.length, skuPurchaseQtyList.length);

    return Array.from({ length: maxLength }).map((_, index) => {
      const articleNo = articleNoList[index] || "-";
      const barCode = barCodeList[index] || "-";
      const skuPurchaseQty = skuPurchaseQtyList[index] || "-";

      return {
        articleNo,
        barCode,
        skuPurchaseQty,
        text: `${articleNo} ${barCode} ${skuPurchaseQty}`,
      };
    }).filter((item) => item.articleNo !== "-" || item.barCode !== "-" || item.skuPurchaseQty !== "-");
  },
  getPurchaseRecordFirstValue(value) {
    const list = this.splitPurchaseRecordValue(value);
    return list.length ? list[0] : "-";
  },
  getPurchaseRecordTooltipContent(row) {
    return this.getPurchaseRecordEntries(row).map((item) => item.text).join("；");
  },
  hasMultiplePurchaseRecordItems(row) {
    return this.getPurchaseRecordEntries(row).length > 1;
  },
  getType(attribute, type) {
    return type
      ? attribute === "paymentTypes" &&
        !this[attribute].filter((v) => v.type === type).length
        ? this[attribute][0].title
        : this[attribute].filter((v) => v.type === type).length
          ? this[attribute].filter((v) => v.type === type)[0].title
          : ""
      : "";
  },
  bjSuccess() {
    //报价成功刷新页面信息
    this.getDetails();
  },
  matchingIndex(type) {
    return this.navs.findIndex((v) => v.type === type);
  },
  getTabIcon(type, isActive) {
    // 根据 tab type 和激活状态返回对应的图标
    const iconMap = {
      1: {
        active: require('@/assets/icons/enquiry/quoted-active-tab.png'),
        inactive: require('@/assets/icons/enquiry/quoted-tab.png')
      },
      2: {
        active: require('@/assets/icons/enquiry/product-active-tab.png'),
        inactive: require('@/assets/icons/enquiry/product-tab.png')
      },
      3: {
        active: require('@/assets/icons/enquiry/enquiry--active-tab.png'),
        inactive: require('@/assets/icons/enquiry/enquiry-tab.png')
      }
    };
    const icons = iconMap[type] || iconMap[3];
    return isActive ? icons.active : icons.inactive;
  },
},
computed: {
    ...mapState("purchaseMudule", [
  "paymentTypes",
  "protects",
  "moneys",
  "documentState",
  "projectState",
]),
    comName() {
    //组件名字
    return this.navs.filter((v) => this.activeNav === v.type)[0].name;
  },
  shareLink() {
    return `${this.protocol}//${this.host}/login/sharePage?id=${this.id}&belongType=0`;
  },
  quoteCount() {
    // 统计总报价数量：遍历所有 SKU 的 enterpriseVOList
    let count = 0;
    const forSku = this.info?.forSku || [];
    forSku.forEach((item) => {
      if (Array.isArray(item.enterpriseVOList)) {
        count += item.enterpriseVOList.length;
      }
    });
    return count;
  },
  companyCount() {
    // 统计报价企业数量：从所有 SKU 的 enterpriseVOList 中提取唯一的企业
    const companySet = new Set();
    const forSku = this.info?.forSku || [];
    forSku.forEach((item) => {
      if (Array.isArray(item.enterpriseVOList)) {
        item.enterpriseVOList.forEach((v) => {
          if (v.sellerEnterpriseId) {
            companySet.add(v.sellerEnterpriseId);
          }
        });
      }
    });
    return companySet.size;
  },
  unquotedSkuCount() {
    // 统计未报价的 SKU 数量
    const itemList = this.info?.itemRequestVOList || [];
    const quotedSkuIds = new Set();
    const forSku = this.info?.forSku || [];
    
    // 收集所有已报价的 SKU ID
    forSku.forEach((item) => {
      if (item.skuId && Array.isArray(item.enterpriseVOList) && item.enterpriseVOList.length > 0) {
        quotedSkuIds.add(String(item.skuId));
      }
    });
    
    // 统计未报价的 SKU
    const unquoted = itemList.filter((item) => {
      const skuId = String(item.skuId || item.itemId);
      return !quotedSkuIds.has(skuId);
    });
    
    return unquoted.length;
  },
},
created() {
  console.log(this.$store.state);
  if (this.$route.query.type) {
    this.type = this.$route.query.type;
  }
  this.id = this.$route.query.id;
  this.getDetails();
},
beforeUnmount() {
  this.isAlive = false;
},
};
</script>

<style scoped lang="less">
  
.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.justify-between {
  justify-content: space-between;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}
.box_2 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
  width: 100%;
  min-height: 377px;
  padding: 0;
  margin: 0 auto;
  box-sizing: border-box;
}

.block_18 {
  width: 288px;
  height: 28px;
  margin: 26px 0 0 19px;
}

.text_6 {
  width: 185px;
  height: 28px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 20px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}

.text-wrapper_1 {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  height: 24px;
  border: 1px solid rgba(235, 73, 73, 1);
  margin-top: 2px;
  width: 66px;
  box-sizing: border-box;
}

.text_7 {
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(235, 73, 73, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
}

.block_19 {
  width: 100%;
  height: auto;
  min-height: 20px;
  margin: 16px 0 0 19px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.right-block {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0px;
  flex-shrink: 0;
}

.text-wrapper_2 {
  width: auto;
  max-width: 376px;
  height: 20px;
  overflow-wrap: break-word;
  font-size: 0;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  flex-shrink: 1;
  min-width: 0;
}

.text_8,
.text_10,
.text_12,
.text_14 {
  display: inline-block;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_9,
.text_11,
.text_13 {
  display: inline-block;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(235, 73, 73, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text-wrapper_3 {
  width: auto;
  max-width: 188px;
  height: 20px;
  overflow-wrap: break-word;
  font-size: 0;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  flex-shrink: 0;
}

.text_15 {
  display: inline-block;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(145, 150, 150, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_16 {
  display: inline-block;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_17 {
  width: auto;
  min-width: 70px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(145, 150, 150, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  margin-left: 19px;
  flex-shrink: 0;
}

.text_18 {
  width: auto;
  max-width: 229px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.link-tooltip-wrapper {
  position: relative;
  display: inline-block;
  max-width: 229px;
  flex-shrink: 1;
  min-width: 0;
}

.link-tooltip-wrapper:hover .tooltip-content {
  opacity: 1;
  visibility: visible;
}

.tooltip-content {
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  z-index: 1000;
  word-break: break-all;
}

.tooltip-content::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.8);
}

.text_19 {
  width: auto;
  min-width: 28px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(72, 160, 156, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 20px;
  flex-shrink: 0;
}

.text_20 {
  width: auto;
  min-width: 120px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(72, 160, 156, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 12px;
  flex-shrink: 0;
}

.image_1 {
  width: 100%;
  height: 1px;
  margin: 16px 0 0 19px;
}

.block_20 {
  width: 100%;
  height: auto;
  min-height: 235px;
  margin: 17px 0 18px 19px;
  display: flex;
  gap: 20px;
}

.box_30 {
  position: relative;
  flex: 1;
  min-width: 0;
  height: auto;
  min-height: 235px;
}

.purchase-record-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.purchase-record-primary {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.purchase-record-more {
  color: #48a09c;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.purchase-record-popover {
  max-height: 240px;
  overflow-y: auto;
}

.purchase-record-popover-item {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 12px;
  line-height: 20px;
  align-items: start;
}

.purchase-record-popover-col {
  word-break: break-all;
}

.purchase-record-popover-item + .purchase-record-popover-item {
  margin-top: 8px;
}

.text-wrapper_4 {
  border-radius: 4px;
  height: 32px;
  border: 1px solid rgba(72, 160, 156, 1);
  width: 80px;
}

.text_21 {
  width: 56px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(72, 160, 156, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 6px 0 0 12px;
}

.box_6 {
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  width: 100%;
  height: auto;
  min-height: 193px;
  overflow: hidden;
  margin-top: 9px;
}

.block_2 {
  background-color: rgba(238, 242, 241, 1);
  border-radius: 4px;
  position: relative;
  width: 284px;
  height: auto;
  min-height: 234px;
  flex-shrink: 0;
}

.section_2 {
  background-color: rgba(124, 194, 191, 1);
  width: 73px;
  height: 5px;
  margin: 29px 0 0 16px;
}

.paragraph_8 {
  width: 100%;
  max-width: 266px;
  height: auto;
  min-height: 40px;
  overflow-wrap: break-word;
  color: rgba(96, 102, 102, 1);
  font-size: 14px;
  text-align: left;
  line-height: 20px;
  margin: 12px 0 0 16px;
}

.image-wrapper_1 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 1px;
  height: 116px;
  width: 116px;
  margin: 15px 0 17px 84px;
}

.image_5 {
  width: 113px;
  height: 112px;
  margin: 2px 0 0 2px;
}

.text_37 {
  position: absolute;
  left: 17px;
  top: 16px;
  width: 70px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.ed {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .ed-info {
    display: flex;
    padding-bottom: 15px;

    .ed-info-i {
      font-size: 14px;
      display: flex;
      flex: 1;

      span {
        color: #999999;
        width: 80px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      p {
        flex: 1;
        padding-right: 40px;
      }
    }

    .ed-p {
      span {
        color: #999999;
        width: 80px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      p {
        flex: 1;
        padding-right: 40px;
      }
    }
  }

  .ed-title {
    padding-bottom: 5px;
    color: @dh-color;
    font-weight: bold;
    line-height: 30px;
  }

  .line {
    height: 15px;
    background: #f2f5fa;
    width: calc(100% + 30px);
    position: relative;
    left: -15px;
  }

  .ed-content {
    flex: 1;
    overflow-y: auto;
  }
}

.tabs-container {
  position: relative;
  width: 100%;

  .custom-tab-label {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .tab-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  .tab-text {
    font-size: 14px;
    color: rgba(96, 102, 102, 1);
    white-space: nowrap;
  }

  .tab-text-active {
    color: rgba(72, 160, 156, 1);
    font-family: PingFangSC-Semibold;
    font-weight: 600;
  }

}

.tabs-right {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
}

.text_38 {
  width: 70px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(145, 150, 150, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 0;
}

.text_39 {
  width: auto;
  min-width: 42px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 2px;
}

.thumbnail_11 {
  width: 1px;
  height: 14px;
  margin: 0 0 0 20px;
  background: rgba(204, 204, 204, 1);
  display: inline-block;
  vertical-align: middle;
  align-self: center;
}

.text_40 {
  width: 42px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(145, 150, 150, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 19px;
}

.text_41 {
  width: auto;
  min-width: 90px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 2px;
}

.thumbnail_12 {
  width: 1px;
  height: 14px;
  margin: 5px 0 0 20px;
  background: rgba(204, 204, 204, 1);
  display: inline-block;
}

.text_42 {
  width: 70px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(145, 150, 150, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 19px;
}

.text_43 {
  width: auto;
  min-width: 112px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 2px;
}

.poster {
  padding: 15px 15px 30px;
  width: 300px;
  display: flex;
  flex-direction: column;

  .posterTitle {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    padding: 20px 0;
  }

  .posterBody {
    width: 300px;
    position: relative;

    .posterBodyText {
      position: absolute;
      top: 45px;
      left: 50%;
      transform: translate(-50%, 0%);
      text-align: center;
      width: 300px;

      p {
        font-size: 12px;
        padding-top: 5px;
      }

      div {
        font-size: 14px;
        font-weight: bold;
        color: #000;

        &:nth-last-child(1) {
          padding-top: 20px;
        }
      }
    }
  }

  .posterQRCode {
    margin: 20px auto;
  }

  .posterQRText {

    text-align: center;

    span {

      font-weight: bold;
    }
  }

  .posterDate {
    text-align: center;
    color: #000;
    font-weight: bold;
    padding-top: 10px;
  }
}
.line-mini {
  height: 1px;
  background: #E6E6E6;
  margin: 16px 0;
}
.icon{
  width: 16px;
  height: 16px;
}
.custom-tabs-label{
  display: flex;
  align-items: center;
}
/deep/ .el-table th {
  background-color: #EBEBEB !important;
}

/deep/ .el-table__header-wrapper th {
  background-color: #EBEBEB !important;
}
.link_wrap{
  display: flex;
  align-items: center;
  height: 100%;
}

</style>
